import OrderItemsBy from './OrderItemsBy.enum';

export default Object.freeze([
	{
		name: 'SKU',
		value: OrderItemsBy.Sku,
	},
	{
		name: 'Name',
		value: OrderItemsBy.Name,
	},
	{
		name: 'Item Quantity (low to high)',
		value: OrderItemsBy.QtyAsc,
	},
	{
		name: 'Item Quantity (high to low)',
		value: OrderItemsBy.QtyDesc,
	},
]);
